import { EditMaterialInputType } from '@shelflix/schemas/material/edit';
import { Card, CardContent, CardHeader, CardTitle } from '@shelflix/ui-web/components/ui/card';
import { FormControl, FormField, FormItem, FormLabel, FormMessage } from '@shelflix/ui-web/components/ui/form';
import { Input } from '@shelflix/ui-web/components/ui/input';
import { UseFormReturn } from 'react-hook-form';
import { checkMaterialCreateInput } from '@shelflix/schemas/material/create';

interface LedControllerSectionProps {
  form: UseFormReturn<
    EditMaterialInputType & {
      cnpj: {
        uuid: string;
        cnpj: string;
        name: string;
      };
      materialTypeUuid: {
        uuid: string;
        name: string;
        brand: {
          name: string;
        };
      };
    }
  >;
}

export function LedControllerSection({ form }: LedControllerSectionProps) {
  return (
    <Card className="rounded-[10px]">
      <CardHeader className="pb-0">
        <CardTitle className="text-primary text-2xl leading-5 font-semibold">Controlador de Led</CardTitle>
      </CardHeader>
      <CardContent>
        <FormField
          control={form.control}
          name="ledControllerId"
          rules={{ validate: (value) => checkMaterialCreateInput('ledController', value) }}
          render={({ field }) => (
            <FormItem className="flex w-full flex-col gap-[3px]">
              <FormLabel className="text-xs font-medium text-[var(--gray-primary)]">Id do controlador</FormLabel>
              <FormControl>
                <Input
                  className="h-[36px] w-[30%]"
                  placeholder="Ex: A1B2C3D4"
                  {...field}
                  value={field.value ?? ''}
                  onChange={(e) => {
                    const upperValue = e.target.value.toUpperCase().slice(0, 12);
                    field.onChange(upperValue);
                  }}
                  maxLength={12}
                />
              </FormControl>
              <FormMessage />
            </FormItem>
          )}
        />
      </CardContent>
    </Card>
  );
}
